module.exports = __webpack_public_path__ + "static/media/logo-header-mobile.5f04393e.jpg";